'use client'

import { cn } from '@/core/lib/utils/cn'

export type WithLabelProps = {
  label?: React.ReactNode
  labelClassName?: string
  labelAlignment?: 'horizontal' | 'vertical'
  description?: React.ReactNode
  descriptionClassName?: string
  name?: string
}

export function withLabel<T extends object>(Component: React.ComponentType<T>) {
  const Wrapped = (
    props: T & WithLabelProps & React.HTMLAttributes<HTMLElement>,
  ) => {
    const {
      label,
      labelClassName,
      labelAlignment = 'vertical',
      className,
      description,
      descriptionClassName,
      name,
      ...rest
    } = props

    return (
      <div
        className={cn(
          labelAlignment === 'vertical'
            ? 'flex flex-col gap-1'
            : 'flex items-center',
          className,
        )}
      >
        {label && (
          <label
            className={labelClassName || 'text-grey text-sm font-medium'}
            htmlFor={name}
          >
            {label}
          </label>
        )}
        {description && (
          <p className={descriptionClassName || 'text-grey text-sm'}>
            {description}
          </p>
        )}
        <Component name={name} id={name} {...(rest as T)} />
      </div>
    )
  }

  return Wrapped
}
